<template>
	<div class="order" v-title data-title="订单模块">
		<leftnav class="fl" itemcode="B-DDTP"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<form id="form1" action="" method="post" class="whitebox pb-5">
					<div class=" banpage  order_page">
						<div class="order_block order_model mt-5">
							<h3 class="bluetitle fl">模块选择</h3>
							<div class="right_table">
								<div class="flexcss widthPC-80">
									<div class="order_price_year recommd" :class="{'active':form.year == 3}" @click="yearClick(3)">
										<h4>3年VIP</h4>
										<p class="font-20 redfont">￥19800</p>
										<p class="garyfont text-center"> 每天仅 <span class="red-font">{{ (19800/365/3).toFixed(0) }}</span> 元</p>
									</div>
									<div class="order_price_year" :class="{'active':form.year == 2}" @click="yearClick(2)">
										<h4>2年VIP</h4>
										<p class="font-20 redfont">￥16800</p>
										<p class="garyfont text-center"> 每天仅 <span class="red-font">{{ (16800/365/2).toFixed(0) }}</span> 元</p>
									</div>
									<div class="order_price_year" :class="{'active':form.year == 1}" @click="yearClick(1)">
										<h4>1年VIP</h4>
										<p class="font-20 redfont">￥ 9800</p>
										<p class="garyfont text-center"> 每天仅 <span class="red-font">{{ (9800/365).toFixed(0) }}</span> 元</p>
									</div>
							</div>
							</div>
							
						</div>
						<div class="order_block order_contact">
							<h3 class="bluetitle mb-3">联系人信息<span>（ <em class="redfont font-20 font-bold">*</em>为必填内容）</span></h3>
							<div class="order_contact_table">
								<div class="inputlist_b fl">
									<label for="" class="labename"><em class="redfont font-20 font-bold">*</em>姓名</label>
									<input type="text" name="name" v-model="form.name" class="order_input mandatory"
										value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename"><em class="redfont font-20 font-bold">*</em>手机号</label>
									<input type="text" name="phone" v-model="form.mobile" class="order_input mandatory"
										value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">性别</label>
									<div class="right_input">
										<span class="fl"><input type="radio" v-model="form.gender" name="gender"
												class="order_input gender1" value="男" />男</span>
										<span class="fl"><input type="radio" v-model="form.gender" name="gender"
												class="gender2 order_input" value="女" />女</span>
									</div>
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">固定电话</label>
									<input type="text" name="telphone" v-model="form.phone" class="order_input"
										value="" />
								</div>
								<div class="inputlist_a fl">
									<label for="" class="labename"><em class="redfont font-20 font-bold">*</em>单位名称</label>
									<input type="text" name="companyName" v-model="form.companyName"
										class="order_input mandatory" value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">职务</label>
									<input type="text" name="position" v-model="form.position" class="order_input"
										value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">邮编</label>
									<input type="text" name="postcode" v-model="form.postcode" class="order_input"
										value="" />
								</div>
								<div class="inputlist_c fl">
									<label for="" class="labename"><em class="redfont font-20 font-bold">*</em>地址</label>
									<input type="text" name="address" v-model="form.address"
										class="order_input mandatory" value="" />
								</div>
								<div class="inputlist_b fl">
									<label for="" class="labename">Email</label>
									<input type="text" name="email" v-model="form.email" class="order_input" value="" />
								</div>
								<div class="inputlist_d fl">
									<label for="" class="labename">备注</label>
									<textarea name="remark" v-model="form.remark" class="order_input"></textarea>
								</div>
							</div>
						</div>
						<div class="order_total order_block">
							<h3 class="bluetitle fl">合计</h3>
							<div class="order_t_list">
								<div class="fl">
									<h5 class="title">总费用</h5>
									<p v-show="Zmodule && form.year == 1"><strong class="orader_model_price">¥ 9800 </strong><em>元</em></p>
									<p v-show="Zmodule && form.year == 2"><strong class="orader_model_price">¥ 16800 </strong><em>元</em></p>
									<p v-show="Zmodule && form.year == 3"><strong class="orader_model_price">¥ 19800 </strong><em>元</em></p>
								</div>
								<div class="fl">
									<h5 class="title">所选模块</h5>
									<p class="active-module font-20" v-show="Zmodule"><span class="color-0069D3">{{curWebsite.shortname}} - </span><strong class="order_model_name" >全库 </strong></p>
								</div>
								<div class="fl">
									<h5 class="title">使用年限</h5>
									<p><strong class="orader_model_year">{{ form.year }}</strong> <em>年</em></p>
								</div>
							</div>
						</div>
						<div class="submitBtn order_submit" @click="submitOrder">提交订单</div>
					</div>
				</form>

			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'chainEnterprise',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse']),
	},
	data() {
		return {
			curWebsite:this.$api.getWebsiteType(), 
			website:'产业研究大脑',
			modulelist: [],
			modulelist_text: [],
			allModule: [],
			Zmodule: true,
			form: {
				module: [],
				year: 3,
				name: '',
				gender: '',
				mobile: '',
				phone: '',
				companyName: '',
				position: '',
				postcode: '',
				address: '',
				email: '',
				remark: '',
			},
		}
	},
	beforeCreate() {

	},
	created() {

	},

	mounted() {
	},
	methods: {
		// 表单验证
		validate(){
			if (this.form.name == ''|| this.form.mobile == ''|| this.form.companyName == ''||this.form.address == '') {
				this.$message.error('*星号为必填项，请完善信息！');
				if(this.form.name == ''){
					document.getElementsByClassName('mandatory')[0].classList.add('error');
				}else if(this.form.mobile == ''){
					document.getElementsByClassName('mandatory')[1].classList.add('error');
				}else if(this.form.companyName == ''){
					document.getElementsByClassName('mandatory')[2].classList.add('error');
				}else if(this.form.address == ''){
					document.getElementsByClassName('mandatory')[3].classList.add('error');
				}
				let elements = document.getElementsByClassName('error')[0];
				console.log(elements.classList);
				elements.scrollIntoView({
					block: 'center', // 值有start,center,end，nearest，当前显示在视图区域中间
					behavior: 'smooth', // 值有auto、instant,smooth，缓动动画（当前是慢速的）
				});
				return false;
			}else{
				return true;
			}
		},
		submitOrder() {
			let falg = this.validate();
			if(falg){
				let ajaxurl = this.$api.free.order.post();
					this.form.module = 'Z';
					if(this.form.year == 1){
						this.form.price = 9800;
					}else if(this.form.year == 2){
						this.form.price = 16800;
					}else if(this.form.year == 3){
						this.form.price = 19800;
					}
				console.log(this.form);
				var _this = this;
				$.ajax({
					type:"POST",
					url:ajaxurl,
					data:_this.form,
					success:function(res){ 
						console.log(res); 
						if(res.success){
						_this.$message.success('提交成功！');
						_this.routerself('/paytype?id='+ res.data.id);
						// _this.$router.push({
						// 	name: 'paytype',
						// 	params:res.data,
						// });
					}else{
						_this.$message.error(res.msg);
					}
					}
				});	 
			}
			
				
		},
		//年份点击
		yearClick(year) {
			this.form.year = year;

		},

		 

	}
}
</script>

<style lang="scss" scoped>
@import url('../../css/order.css');

.whitebg {
	background-color: #fff;
	padding-bottom: 100px;
}

.order_page {
	min-width: 1336px;
	width: 90%;
	margin: 0 auto;
	max-width: 1498px;
}

.active-module {
	width: 400px;
	line-height: 32px;
}
.detailbtn{
	cursor: pointer;
	&:hover{
		color: #0071ce;
	}
}
.order_price_year{
	border: 1px solid rgb(202, 202, 202);
	width: 180px;
	height: 180px;
	border-radius: 10px;
	text-align: center;
	vertical-align: middle;
	cursor: pointer;
	background: linear-gradient(to bottom right, #ffffff, #e6e4e4);
	&.active{
		border: 2px solid rgb(197, 7, 7);
		background: url(../../assets/images/order_year_bg.png) no-repeat;
	}
	h4{
		font-size: 28px;
		color: rgb(175, 79, 0);
		line-height: 40px;
		padding: 10px 0;
		margin-top: 30px;
	}
	.redfont{
		font-weight: bold;
		font-size: 26px;
		margin-bottom: 10px;
	}
	.garyfont{
		// font-weight: bold;
		font-size: 14px;
		color: #949494;
		// text-decoration: line-through;
	}
}
.recommd{
		position: relative;
		&::before{
			content: '';
			width: 100px;
			height: 32px;
			position: absolute;
			top: -4px;
			left: -2px;
			display: inline-block;
			background-image:url(../../assets/images/orderRecomd.png);
			background-size: 100% 100%;
			background-position: 0 0;
			background-repeat: no-repeat;
			// opacity: .7;
		}
	}
</style>
